export const router = [
  {
    path: "device",
    component: (resolve) => require(["./layout/Index.vue"], resolve),
    children: [
      {
        path: "mgmt",
        component: (resolve) => require(["./device-mgmt/Index.vue"], resolve),
      },
      {
        path: "control",
        component: (resolve) =>
          require(["./device-control/Index.vue"], resolve),
      },
      {
        path: "config/retrieval",
        // redirect: "config/retrieval?key=hikConfig",
        component: (resolve) =>
          require(["./config-firmware/Index.vue"], resolve),
      },
      {
        path: "config/Import",
        component: (resolve) =>
          require(["./config-firmware/Import.vue"], resolve),
      },
      {
        path: "config/test",
        component: (resolve) =>
          require(["./config-firmware/my-config/ConfigTest.vue"], resolve),
      },
      {
        path: "config/fileModel",
        component: (resolve) =>
          require(["./config-firmware/file-model/Index.vue"], resolve),
      },
    ],
  },
];
